export default __webpack_public_path__ + "static/media/callouts description window.c465ca42.png";